import { axiosBackEndInstance } from '../Axios';
import { END_POINT_OPERATION_CURRENCY_AVERAGES } from '../Axios/ENDPOINTS';
import { useErrorHandling } from '../hooks/useErrorHandling';

export interface CurrencyAverageItem {
  main_currency: { id: number; name: string; sign: string };
  secondary_currency: { id: number; name: string; sign: string };
  avg_buy_price: string | null;
  avg_sell_price: string | null;
  count: number;
}

export const useCurrencyExchangeAverages = () => {
  const { errorHandling } = useErrorHandling();

  const getCurrencyExchangeAverages = async (
    start_date: string,
    end_date: string,
    setLoading?: (loading: boolean) => void
  ): Promise<CurrencyAverageItem[] | undefined> => {
    try {
      const data = await axiosBackEndInstance.get(
        END_POINT_OPERATION_CURRENCY_AVERAGES,
        { params: { start_date, end_date } }
      );
      if (data.status === 200 || data.status === 201) {
        if (setLoading) setLoading(false);
        return data.data;
      }
      if (setLoading) setLoading(false);
    } catch (newError) {
      const status = errorHandling(newError).request.status;
      console.log('status: ' + status + ' ' + newError);
      if (setLoading) setLoading(false);
    }
  };

  return { getCurrencyExchangeAverages };
};
